import { BoardTypeLocalPersistenceContext } from "~applications";
import { createStaticContextProvider, lazyValue } from "~utils";

export const BoardTypeLocalPersistenceProvider = createStaticContextProvider(
  BoardTypeLocalPersistenceContext,
  lazyValue(() =>
    import("./board-type-local-persistence").then(
      (module) => module.boardTypeLocalPersistence,
    ),
  ),
);
